import { Box } from '@mui/material';
import { radius } from '@karehero/llama/theme/radius';

// iOS home-indicator element. This 47px-tall zone IS the bottom safe area —
// content sits above it. The pill sits near the bottom edge.
export const HOME_INDICATOR_H = 47;

const HomeIndicator = () => (
  <Box
    sx={{
      height: HOME_INDICATOR_H,
      flexShrink: 0,
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'center',
      pb: 1,
    }}
  >
    <Box
      sx={{
        width: 134,
        height: 5,
        borderRadius: `${radius.xxl}px`,
        bgcolor: 'text.primary',
        opacity: 0.9,
      }}
    />
  </Box>
);

export default HomeIndicator;
